(function ($) {
    let body = $('body');
    let navContainer = $('.c-header__navigation');
    let navigation = $('.c-navigation');
    let toggle = $('.c-navigation__toggle');
    let side = $('.c-navigation__side');
    if (navigation) {
        if ($(window).width() > 991) {
            if (side) {
                let items = $(navigation).find('.c-navigation__item.menu-item-has-children');
                if (items) {
                    items.each(function () {
                        let item = $(this);
                        let menuHeight = $(this).find('ul.sub-menu').innerHeight();
                        side.css({height: menuHeight});
                        let clone = $(side).clone();
                        item.append(clone);
                        item.on('click', function (event) {
                            if (item.hasClass('disabled')) {
                                event.preventDefault();
                            }
                        });
                        item.on('mouseenter mouseleave', function () {
                            item.toggleClass('c-navigation__item--open');
                        });
                    });
                }
            }
        } else {
            let items = $(navigation).find('.c-navigation__item.menu-item-has-children');
            if (items) {
                items.each(function () {
                    let item = $(this);
                    let toggle = item.find('.c-navigation__item-toggle');
                    let submenu = item.find('ul.sub-menu');
                    item.on('touch, click', function (event) {
                        if (event.target != this) {
                            return;
                        }
                        event.preventDefault();
                        item.toggleClass('c-navigation__item--open');
                    });
                    toggle.on('touch, click', function (event) {
                        event.preventDefault();
                        navContainer.addClass('submenu');
                        submenu.addClass('sub-menu--open');
                    });
                });
            }
        }
        if (toggle) {
            toggle.on("touch, click", function () {
                if (navContainer.hasClass('submenu')) {
                    navContainer.toggleClass('submenu--closing');
                    setTimeout(function () {
                        navContainer.toggleClass('submenu--closing');
                        navContainer.toggleClass('submenu');
                    }, 400);
                    $('ul.sub-menu.sub-menu--open').toggleClass('sub-menu--open');
                    return;
                }
                body.toggleClass('no-scroll');
                navContainer.toggleClass('c-header__navigation--open');
            });
        }
    }

    let header = $('.c-header');
    if (header) {
        let scrollPos = 0;
        $(window).on('scroll', function (event) {
            if ($(this).scrollTop() > 200) {
                header.addClass('c-header--white');
                if ($(this).scrollTop() > scrollPos) {
                    header.addClass('hidden');
                } else {
                    if (header.hasClass('hidden')) {
                        header.addClass('hiding');
                        setTimeout(function () {
                            header.removeClass('hiding');
                            header.removeClass('hidden');
                        }, 275);
                    }
                }
                scrollPos = $(this).scrollTop();
            } else {
                header.removeClass('c-header--white');
            }
        });
    }

    let _overlays = document.querySelectorAll('.c-navigation, .c-popup__container');

    Array.prototype.forEach.call(_overlays, function (_overlay) {
        let _clientY = null;
        _overlay.addEventListener('touchstart', function (event) {
            if (event.targetTouches.length === 1) {
                _clientY = event.targetTouches[0].clientY;
            }
        }, false);
        _overlay.addEventListener('touchmove', function (event) {
            if (event.targetTouches.length === 1) {
                disableRubberBand(event);
            }
        }, false);

        function disableRubberBand(event) {
            let clientY = event.targetTouches[0].clientY - _clientY;
            if (_overlay.scrollTop === 0 && clientY > 0) {
                event.preventDefault();
            }
            if (isOverlayTotallyScrolled() && clientY < 0) {
                event.preventDefault();
            }
        }

        function isOverlayTotallyScrolled() {
            return _overlay.scrollHeight - _overlay.scrollTop <= _overlay.clientHeight;
        }
    });
})(jQuery);
